import { useTranslation } from 'react-i18next';
import { Fragment, useState, useContext, useRef, useEffect } from 'react';
import {
  PersonAvatar,
  PageHeader,
  IconButton,
  Button,
  Tabs,
  InputText,
  Tag,
  TEOLoader,
  ProgressBar,
} from '@teo/components';
import {
  Search,
  ArrowRight,
  CommentBoxFilled,
  CommentBox,
  CrossFilled,
  Eye,
  Check,
} from '@teo/components/icons';
import { useGet } from '@/query/fetchHooks';
import { useNavigate, useParams } from 'react-router-dom';
import i18n from 'i18next';
import { axios } from '@/axios';
import { config } from '@/config';
import { format } from 'date-fns';
import { newUid, nthLastIndexOf, downloadLink } from '@/util';
import { DataTable } from '@/components/DataTable/DataTable';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Userwithorganisationwithidps } from '@/models';
import OptionsAction from '@/components/DataTable/OptionsAction';
import { TeamsTableLP } from '@/components/TeamsTableLP';
import StepsComponentLP from '../AddCourseLP/StepsComponentLP';
import { LearningPathContent } from '@/components/LearningPath/FollowUp/LearningPathContent';
import RigthSidebar from './RigthSidebar';
import OpenCommentModal from '../OpenCommentModal/OpenCommentModal';
import ComponentDeleteModal from '@/components/DeleteModal/ComponentDeleteModal';
import { BreadCrumbsDetails } from '@/components/BreadCrumbsDetails';
import ReportDownloadModal from '@/components/ReportDataTable/ReportDownloadModal';
import DownloadReportModal from '@/pages/Protected/Organisation/ReportPage/DownloadReportModal';

function useOutsideClick(ref: any, handler: any) {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

function LearningPathDetails() {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const tableRef = useRef<HTMLDivElement | null>(null);
  const authUser = auth?.user as Userwithorganisationwithidps;
  const authOrg: any = auth?.user?.activeOrganisationId;
  const { organisationId, lpgroupId }: any = useParams();
  const navigate = useNavigate();

  const userPath = `/${i18n.language}/follow-up/${organisationId}/users`;
  const managePath = `/${i18n.language}/manage/${organisationId}/users`;
  const teamPath = `/${i18n.language}/follow-up/${organisationId}/teams`;

  const [tab, setTab] = useState('users');

  const [learningpath, setLearningpath] = useState<any>();
  const [isFollow, setIsFollow] = useState(false);
  const [shareSettings, setShareSettings] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState(1);

  const [usr, setUsr] = useState<any>();
  const [allStudents, setAllStudents] = useState([]);
  const [resetUserTable, setResetUserTable] = useState<string>(newUid(20));
  const [resetContent, setResetContent] = useState(newUid(20));
  const [usrSelected, setUsrSelected] = useState<any>();
  const [userInpFilter, setUserInpFilter] = useState('');
  const [selected, setSelected] = useState<Set<string | number>>(
    new Set<string | number>()
  );
  const [deselect, setDeselect] = useState<boolean>(false);
  const [isOpenCommentModal, setIsOpenCommentModal] = useState(false);
  const [isOpenRedoModal, setIsOpenRedoModal] = useState(false);

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [usrDelete, setUsrDelete] = useState<any>();

  const [preloader, setPreloader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [lpInfo, setLpInfo] = useState<any>(null);

  const [activeUser, setActiveUser] = useState('');
  const [activeTeam, setActiveTeam] = useState('');

  const [follows, setFollows] = useState([]);
  const [activeFollower, setActiveFollower] = useState<any>(null);
  const [isOpenUser, setIsOpenUser] = useState(false);
  const [isOpenTeam, setIsOpenTeam] = useState(false);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState<any>(null);
  const [content, setContent] = useState<any>(null);

  const [resetSidebar, setResetSidebar] = useState(newUid(10));

  const [isOpenDownloadReportModal, setIsOpenDownloadtReportModal] =
    useState(false);
  const [payloadDownload, setPayloadDownload] = useState<any>(null);

  const [downloadReportPayload, setDownloadReportPayload] = useState<any>(null);
  const [isOpenDownloadtModal, setIsOpenDownloadtModal] = useState(false);

  const basePath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 2)
  );

  let pageDetail: any = undefined;

  const { refetch } = useGet(
    `/memberlpgroupdetail/${organisationId}/${lpgroupId}`,
    {
      retry: false,
      onSuccess: (res: any) => {
        setLearningpath(res?.data || undefined);
      },
    }
  );

  if (
    Math.max(authUser?.role || 0, authUser?.activeOrganisationRole || 0) >= 90
  ) {
    pageDetail = {
      title: t('pages.follow_up_courses.manage_user'),
      rowPath: (usr: any) => `${userPath}/${usr.id}`,
    };
  }

  const { refetch: refetchInfo } = useGet(`/lpinfo/${lpgroupId}`, {
    retry: false,
    onSuccess: (res: any) => {
      setLpInfo(res?.data);
    },
  });

  useGet(`/learningpathnodedetails`, {
    enabled: !!learningpath,
    learningpathId: learningpath?.learningpathId,
    organisationId: organisationId,
    onSuccess: async (res: any) => {
      const nodedetails = res?.data?.filter((el: any) => el?.type !== 'root');
      if (nodedetails?.length > 0) {
        setContent(nodedetails);
      }
    },
  });

  useGet(`/tracklpgroupdetails`, {
    organisationId: organisationId,
    userId: auth?.user?.id,
    lpgroupId: lpgroupId,
    onSuccess: (result: any) => {
      result && result?.data?.length > 0 && setIsFollow(true);
    },
  });

  useOutsideClick(tableRef, () => {
    setIsOpenUser(false);
    setIsOpenTeam(false);
    setActiveUser('');
    setActiveTeam('');
    setActiveFollower(null);
    setSelectedTeam(null);
  });

  useEffect(() => {
    if (learningpath) {
      axios.post(config.backend + '/activity', {
        userId: auth?.user?.id,
        subjectId: learningpath?.id,
        activityType: 'learnPath',
        subject: learningpath.lpgroupName || learningpath.lpName,
        logo: learningpath.lpgroupPicture || learningpath.lpPicture,
        link: window.location.pathname,
      });
    }
  }, [learningpath]);

  useEffect(() => {
    const mls = content?.filter((el: any) => el?.subType === 'milestone');
  }, [content]);

  const getSelectedUserIds = () => {
    if (deselect) {
      return (allStudents as any[])
        ?.filter((obj: any) => !selected.has(obj.id))
        ?.map((obj: any) => obj.id);
    }

    return Array.from(selected);
  };

  const openBulkReportModal = (payload: any) => {
    const userIds = getSelectedUserIds();

    if (!userIds?.length) return;

    setDownloadReportPayload({
      lang: i18n.language,
      organisationId,
      lpIds: lpgroupId,
      userIds,
      ...payload,
    });

    setIsOpenDownloadtModal(true);
  };

  const bulkReportMenuItems = [
    {
      id: 'bulk-detailed-lp-report',
      title: t('report.lpOverviewDetailed'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'lpOverview',
          noCompetences: true,
        });
      },
    },
    {
      id: 'bulk-detailed-competence-lp-report',
      title: t('report.courseOverviewDetailedCompetences'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'lpOverview',
        });
      },
    },
    {
      id: 'bulk-lp-report',
      title: t('report.lpOverview'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'lpOverview',
          noCompetences: true,
          noBirth: true,
          noDiploma: true,
          noNodes: true,
        });
      },
    },
    {
      id: 'bulk-competence-lp-report',
      title: t('report.courseOverviewCompetences'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'courseOverview',
          noBirth: true,
          noDiploma: true,
          noNodes: true,
        });
      },
    },
  ];

  const handleDeleteUser = async (usr: any) => {
    await axios.delete(
      `${config.backend}/lpfollow/${learningpath?.id}/${usr?.studentId}`
    );
    refetch();
    setResetUserTable(newUid(20));

    setIsOpenDeleteModal(false);
  };

  if (shareSettings) {
    //opens the settings with only the second step loaded
    return (
      <div className="fixed top-0 left-0 z-[100] h-screen w-screen overflow-y-auto bg-white">
        {preloader && (
          <div className="fixed inset-0 z-[13] flex bg-white/75">
            <div className="m-auto">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[110px]"
              />
            </div>
          </div>
        )}
        <div className="flex min-h-20 flex-col justify-start py-2 pr-2 sm:flex-row sm:items-center">
          <div
            data-testid="clouseBtn"
            className="flex min-h-20 items-center justify-start"
          >
            <IconButton
              className="my-auto mx-3 sm:mx-6"
              Icon={CrossFilled}
              variant="ghost"
              onClick={() => {
                document.body.style.overflow = 'unset';
                setShareSettings(false);
              }}
            />
            <div className="flex items-center">
              <div className="mr-5 w-20 min-w-20">
                <img
                  src={
                    learningpath?.lpgroupPicture ||
                    learningpath?.lpPicture ||
                    '/assets/images/LearnPath.png'
                  }
                  alt={learningpath?.lpName}
                  className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                />
              </div>
              <div className="flex flex-wrap">
                <span className="mr-2 font-semibold">
                  {learningpath?.lpgroupName || learningpath?.lpName}
                </span>
                <Tag
                  variant="error"
                  title={t('pages.follow_up_teams.status_ongoing')}
                ></Tag>
              </div>
            </div>
          </div>
        </div>
        <StepsComponentLP
          authUser={authUser}
          learningpath={learningpath}
          lpInfo={lpInfo}
          activeLP={learningpath}
          activeSteps={[1, 2, 3, 4]}
          activeStep={activeStep}
          submitButtonLabel={'button.save'}
          onClose={() => {
            setShareSettings(false);
          }}
          onSubmit={() => {
            setTimeout(() => {
              refetch();
              refetchInfo();
              setPreloader(false);
              setShareSettings(false);
            }, 300);
          }}
          setLoader={setPreloader}
        />
      </div>
    );
  }

  const handleReminder = async () => {
    if (deselect) {
      const filteredIds = allStudents
        ?.filter((obj: any) => !selected.has(obj.id))
        ?.map((obj: any) => obj.id);

      for (const userId of filteredIds) {
        // await axios.post(`${config.backend}/invite/reminder`, {
        //   courseId: course?.id,
        //   userId: userId,
        // });
      }
    } else {
      for (const userId of selected) {
        // await axios.post(`${config.backend}/invite/reminder`, {
        //   courseId: course?.id,
        //   userId: userId,
        // });
      }
    }
  };

  if (!learningpath) return null;

  return (
    <>
      <div className="w-full max-w-6xl flex-col pb-8">
        <div className="pb-2">
          <BreadCrumbsDetails
            prevPathname={basePath}
            prevName={t(`breadcrumbs.LEARNINGPATH`)}
            pathname={window.location.pathname}
            name={learningpath?.lpgroupName || learningpath?.lpName}
            parentPathname={`${basePath}/${learningpath?.masterId}`}
            parentName={learningpath?.lpName}
          />
          <PageHeader /* @ts-expect-error eslint-disable-next-line */
            to={-1}
            ariaLabel={'placeholder'}
          >
            <div className="flex w-full items-center py-4 lg:py-6">
              <div className="flex items-center">
                <div className="w-16 min-w-16 lg:w-24 lg:min-w-24">
                  <img
                    src={
                      learningpath?.lpgroupPicture ||
                      learningpath?.lpPicture ||
                      '/assets/images/LearnPath.png'
                    }
                    alt={learningpath?.lpName}
                    className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                  />
                </div>
              </div>

              <div className="mx-4 flex w-full flex-col justify-between gap-4 xl:flex-row">
                <div className="flex flex-[1] flex-col content-center">
                  <div className="flex flex-row flex-wrap items-center pb-1.5">
                    <h1 className="mr-3 break-all text-base font-semibold text-black md:text-lg lg:text-xl">
                      {learningpath?.lpgroupName || learningpath?.lpName}
                    </h1>
                    <Tag
                      title={
                        learningpath?.lpStatus === 'active'
                          ? t('button.open')
                          : t('button.close')
                      }
                      variant={
                        learningpath?.lpStatus === 'active'
                          ? 'success'
                          : 'default'
                      }
                    />
                  </div>
                  <div className="flex flex-wrap content-center text-xs text-[#919193]">
                    <p className="mr-2 border-r border-[#919193] pr-2 ">
                      {t(`courseTypes.learning-path`)}
                    </p>
                    <p className="mr-2 border-r border-[#919193] pr-2 ">
                      {t('columns.version')} {learningpath?.version}
                    </p>
                    <p className="mr-2 pr-2 ">{learningpath?.lpName}</p>
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  <div className="">
                    <Button
                      variant="outline"
                      size="md"
                      containsOnlyIcon={true}
                      onClick={async () => {
                        if (isFollow) {
                          await axios.delete(
                            `${config.backend}/tracklpgroup/${auth?.user?.id}/${lpgroupId}`
                          );
                          setIsFollow(!isFollow);
                        } else {
                          await axios.post(`${config.backend}/tracklpgroups`, {
                            userId: auth?.user?.id,
                            lpgroupId: lpgroupId,
                          });
                          setIsFollow(!isFollow);
                        }
                      }}
                    >
                      {isFollow ? (
                        <img
                          src="/images/components/follow_up_courses/star_icon.svg"
                          alt="star_icon"
                          className="h-5"
                        />
                      ) : (
                        <img
                          src="/images/components/follow_up_courses/star_white.svg"
                          alt="star_icon"
                          className="h-5"
                        />
                      )}
                    </Button>
                  </div>

                  <div className="rounded-lg border border-grey-02">
                    {learningpath?.lpStatus !== 'disabled' && (
                      <Button
                        variant="destruct"
                        size="md"
                        className="flex items-center"
                        onClick={async () => {
                          const result = await axios.put(
                            `${config.backend}/lpgroup/${learningpath.id}`,
                            {
                              lpStatus: 'disabled',
                            }
                          );
                          setLearningpath(
                            Object.assign({}, learningpath, result?.data)
                          );
                        }}
                      >
                        {t('pages.follow_learningpath.close_edition')}

                        <ArrowRight className="ml-2 h-5 w-5" />
                      </Button>
                    )}
                    {learningpath?.lpStatus == 'disabled' && (
                      <Button
                        //variant="destruct"
                        size="md"
                        className="flex items-center"
                        onClick={async () => {
                          const result = await axios.put(
                            `${config.backend}/lpgroup/${learningpath.id}`,
                            {
                              lpStatus: 'active',
                            }
                          );
                          setLearningpath(
                            Object.assign({}, learningpath, result?.data)
                          );
                        }}
                      >
                        {t('pages.follow_learningpath.open_edition')}
                        <ArrowRight className="ml-2 h-5 w-5" />
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </PageHeader>
          <div className="mb-6 flex flex-wrap justify-between gap-3 rounded-lg border border-grey-02 p-5 sm:py-7 sm:px-9">
            <div className="flex w-full flex-row items-center gap-3">
              <div className="flex flex-col gap-3 sm:flex-row">
                <h4 className="text-base">
                  {t('pages.follow_learningpath.edition_settings')}
                </h4>
              </div>

              <div className="ml-auto">
                <Button
                  variant="text"
                  onClick={() => {
                    setShareSettings(true);
                    setActiveStep(3);
                  }}
                >
                  {t('pages.follow_learningpath.edit_edition_settings')}
                </Button>
              </div>
            </div>
            <div className="flex flex-col gap-3 lg:flex-row lg:gap-8">
              <div className="flex flex-col gap-2">
                <p className="flex text-sm text-grey-08">
                  <span className="w-48">{t('columns.start_date')}</span>
                  <span className="text-grey-06">
                    {learningpath?.lpStartDate
                      ? format(
                          new Date(learningpath?.lpStartDate),
                          'dd/MM/yyyy'
                        )
                      : ''}
                  </span>
                </p>
                <p className="flex text-sm text-grey-08">
                  <span className="w-48">{t('columns.end_date')}</span>
                  <span className="text-grey-06">
                    {learningpath?.lpEndDate
                      ? format(new Date(learningpath?.lpEndDate), 'dd/MM/yyyy')
                      : t('pages.follow_up_teams.not_finished_yet')}
                  </span>
                </p>
                <p className="flex text-sm text-grey-08">
                  <span className="w-48">
                    {t(`pages.learning_path.mandatory`)}
                  </span>
                  <span className="text-grey-06">
                    {learningpath?.isMandatory
                      ? t('pages.follow_up_teams.yes')
                      : t('pages.follow_up_teams.no')}
                  </span>
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <p className="flex text-sm text-grey-08">
                  <span className="w-48">
                    {t('pages.follow_up_teams.access')}
                  </span>
                  <span className="capitalize text-grey-06">
                    {learningpath?.lpgroupAccess === 'protected' ? (
                      <>
                        {t('pages.course_content_flow.step_3.public')}&nbsp;
                        <span className="block font-semibold">
                          {authUser?.organisationName &&
                            authUser?.organisationName}
                        </span>
                      </>
                    ) : (
                      t('pages.course_content_flow.step_3.ivite')
                    )}
                  </span>
                </p>
                <p className="flex text-sm text-grey-08">
                  <span className="w-48">
                    {t('pages.create_courses.certificate')}
                  </span>
                  <span className="text-grey-06">__</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="my-6 flex flex-col gap-3 font-medium sm:flex-row sm:items-center">
          <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
            <>
              <Tabs.TabButton name="users">
                <span>{t('columns.students')}</span>
                <span className="ml-2 text-base text-[#919193]">
                  {learningpath?.nrOfStudents}
                </span>
                {learningpath?.tasksRemaining > 0 && (
                  <span className="ml-2 h-2 w-2 rounded-full bg-[#fc6232]"></span>
                )}
              </Tabs.TabButton>
              <Tabs.TabButton name="teams">
                <span>{t('links.teams')}</span>
                <span className="ml-2 text-base text-[#919193]">
                  {learningpath?.nrOfTeams}
                </span>
              </Tabs.TabButton>

              {/* <Tabs.TabButton name="teachers">
                <span>{t('Teachers')}</span>
                <span className="ml-2 text-base text-[#919193]">
                  {learningpath?.nrOfTeachers}
                </span>
              </Tabs.TabButton> */}
              <Tabs.TabButton name="content">
                <span>{t('pages.course_landing.contents')}</span>
                <span className="ml-2 text-base text-[#919193]">
                  {learningpath?.nrOfNodes}
                </span>
              </Tabs.TabButton>
            </>
          </Tabs>
          {tab === 'users' && (
            <div className="sm:ml-auto ">
              <Button
                onClick={() => {
                  setShareSettings(true);
                  setActiveStep(1);
                }}
                variant="outline"
              >
                {t('pages.manage_add_users.add_users_button')}
              </Button>
            </div>
          )}
        </div>
        {tab === 'users' && (
          <Fragment>
            <div className="flex w-full flex-col justify-between lg:flex-row lg:items-center">
              <div className="pb-4 pt-2 md:w-1/2 xl:w-1/3">
                <InputText
                  value={userInpFilter}
                  onChange={(ev) => setUserInpFilter(ev.target.value)}
                  Icon={Search}
                  placeholder={t('search.user')}
                />
              </div>
              {(selected?.size > 0 || deselect) && (
                <div className="mt-6 flex flex-row lg:mt-0">
                  {/* <Button
                    onClick={() => handleReminder()}
                    size="sm"
                    disabled={selected?.size < 1 && !deselect}
                    variant="outline"
                    className="!text-error-04"
                  >
                    {t('pages.follow_up_users.send_reminder')}
                  </Button> */}
                  <OptionsAction
                    menuItems={bulkReportMenuItems}
                    rowInfo={{}}
                    positionDropdown={true}
                    styleDropdown={{
                      top: '30px',
                      left: 'auto',
                      right: '0',
                    }}
                  />
                </div>
              )}
            </div>
            {loader && (
              <div className="mx-auto flex w-full justify-center py-20 px-10">
                <TEOLoader
                  loaderSrc="/images/TEOloader.gif"
                  className="w-[100px]"
                />
              </div>
            )}
            <div ref={tableRef} className={`${loader === true && ' hidden '}`}>
              <DataTable
                uniqueKey="studentId"
                key={resetUserTable}
                filter={userInpFilter}
                rowPath={(user) => `${userPath}/${user.studentId}`}
                selectable={{
                  selected: selected,
                  setSelected: setSelected,
                  deselect: deselect,
                  setDeselect: setDeselect,
                  checkboxIconMobileType: 'circle',
                }}
                defaultSort={[
                  { id: 'username', desc: false },
                  { id: 'lpProgress', desc: false },
                ]}
                fetch={useGet.bind(null, '/mylpfollows', {
                  userId: authUser?.id,
                  organisationId: authUser?.activeOrganisationId,
                  lpgroupId: learningpath?.id,
                  onSuccess: (result: any) => {
                    if (result?.data?.length > 0) {
                      setFollows(result?.data);
                    }
                    setLoader(false);
                  },
                  onError: (res: any) => {
                    console.error('res', res);
                    setLoader(false);
                  },
                })}
                empty={{
                  template: 1,
                  text: t('empty_tenplate.user_list'),
                  btn_text: t('empty_tenplate.btn_add_user'),
                  btnClick: () => setShareSettings(true),
                }}
                screensUpdateTable="mobile"
                columns={[
                  {
                    title: t('columns.username'),
                    id: 'username',
                    className: 'col-start-1 col-end-9 row-start-1',
                    render: (usr: any) => (
                      <div className="flex items-center">
                        <PersonAvatar
                          inline
                          id={usr?.studentId}
                          name={usr.username || ''}
                          imageSrc={usr.picture || undefined}
                        ></PersonAvatar>
                        <div>
                          <div
                            className={`overflow-hidden text-ellipsis text-sm font-medium ${
                              i18n.language === 'fr'
                                ? 'max-w-[135px]'
                                : 'max-w-[180px]'
                            }`}
                          >
                            {usr.username}
                          </div>
                          <div
                            className={`max-w-[180px] overflow-hidden text-ellipsis text-xs text-[#7d7d81] ${
                              i18n.language === 'fr'
                                ? 'max-w-[135px]'
                                : 'max-w-[180px]'
                            }`}
                          >
                            {usr.email}
                          </div>
                        </div>
                      </div>
                    ),
                  },
                  {
                    addTitleOnMobile: true,
                    id: 'startDate',
                    title: t('columns.start_date'),
                    align: 'right',
                    className: 'col-start-1 col-end-7 row-start-2',

                    render: (usr) =>
                      usr.lpStartDate ? (
                        format(new Date(usr.lpStartDate || ''), 'dd/MM/yyyy')
                      ) : (
                        <p className="text-[#fc6232]">
                          {t('pages.follow_up_users.not_started_yet')}
                        </p>
                      ),
                  },
                  {
                    addTitleOnMobile: true,
                    id: 'updatedAt',
                    title: t('columns.last_active'),
                    align: 'right',
                    className:
                      'col-start-7 col-end-10 row-start-2 text-right justify-end',
                    render: (usr) =>
                      usr.lpProgress === 0 ? (
                        <p>-</p>
                      ) : (
                        format(new Date(usr.updatedAt || ''), 'dd/MM/yyyy')
                      ),
                  },
                  {
                    addTitleOnMobile: true,
                    className: 'col-start-1 col-end-10 row-start-3',
                    classNameDesktop: 'max-w-[150px] w-[150px]',
                    id: 'progress',
                    align: 'right',
                    title: t('columns.progress'),
                    render: (usr: any) => (
                      <>
                        {usr?.isBlocked ? (
                          <Tag
                            title={t(`pages.follow_learningpath.terminated`)}
                            variant="error"
                          />
                        ) : (
                          <div className="flex w-[calc(100vw_-_72px)] items-center justify-end sm:w-auto">
                            <div className="flex w-full sm:w-[80px]">
                              <ProgressBar
                                max={100}
                                value={Math.round(usr.lpProgress * 100)}
                                className={`h-1 overflow-hidden rounded-lg ${
                                  usr.lpProgress === 1 && 'progress-bar__all'
                                }`}
                              />
                            </div>
                            <span className="pl-3 text-xs text-grey-06">
                              {Math.round(usr.lpProgress * 100)}%
                            </span>
                          </div>
                        )}
                      </>
                    ),
                  },
                  {
                    id: 'tasksRemaining',
                    sortable: false,
                    title: '',
                    align: 'right',
                    className: 'col-start-4 col-end-10 row-start-4 justify-end',
                    classNameDesktop: 'max-w-[50px] w-[50px]',
                    render: (usr) => (
                      <div className="z-[2]">
                        <Button
                          variant={usr.lpProgress === 1 ? 'primary' : 'ghost'}
                          className="relative z-[2] pl-0 md:px-0 lg:px-0 xl:px-2"
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            navigate(
                              `${basePath}/correction/${lpgroupId}/${usr.studentId}`
                            );
                          }}
                        >
                          {usr.lpProgress === 1 ? (
                            <Check className="h-5 w-5 text-black" />
                          ) : (
                            <Eye className="h-5 w-5 text-grey-06" />
                          )}
                        </Button>
                      </div>
                    ),
                  },
                  {
                    addTitleOnMobile: false,
                    sortable: false,
                    className: 'col-start-1 col-end-8 row-start-4',
                    id: 'comment',
                    align: 'right',
                    title: '',
                    classNameDesktop: '!px-0 max-w-[50px] w-[50px]',
                    render: (usr: any) => (
                      <Button
                        variant="ghost"
                        className="relative z-[2] pl-0 md:px-0 lg:px-0 xl:px-2"
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          setUsr(usr);
                          setIsOpenCommentModal(true);
                        }}
                      >
                        {usr.nrOfStudentComments > 0 && (
                          <span className="z-1 absolute right-0 top-0 rounded border border-[#ff8a82] bg-[#ff3c2f] py-0 px-1 text-xs font-normal text-white">
                            {usr.nrOfStudentComments}
                          </span>
                        )}
                        {usr.nrOfStudentComments > 0 ? (
                          <CommentBoxFilled className="h-5 w-5 text-grey-06" />
                        ) : (
                          <CommentBox className="h-5 w-5 text-grey-06" />
                        )}
                      </Button>
                    ),
                  },
                  {
                    id: 'actionButton',
                    sortable: false,
                    title: '',
                    className: 'col-start-9 row-start-1 justify-end',
                    classNameDesktop: '!px-1 max-w-[50px] w-[50px]',
                    render: (usr: any) => (
                      <OptionsAction
                        menuItems={[
                          {
                            addIcon: true,
                            hidden: !(
                              Math.max(
                                authUser?.role || 0,
                                authUser?.activeOrganisationRole || 0
                              ) >= 90
                            ),
                            id: '2',
                            title: t('pages.follow_up_courses.manage_user'),
                            onClick: () =>
                              navigate(`${managePath}/${usr?.studentId}`),
                          },
                          {
                            addOnMobile: true,
                            itemDelete: true,
                            id: '5',
                            onClick: () => {
                              setIsOpenDeleteModal(true);
                              setUsrDelete(usr);
                            },
                            title: t(
                              'pages.follow_learningpath.remove_from_lp'
                            ),
                          },
                          {
                            id: 'support',
                            addOnMobile: true,
                            title: t('pages.follow_up_courses.reports', {
                              defaultValue: 'Reports',
                            }),
                            children: [
                              {
                                id: '4_detailed_lp_report',
                                title: t('report.lpOverviewDetailed'),
                                onClick: async () => {
                                  setIsOpenDownloadtReportModal(true);
                                  setPayloadDownload({
                                    formType: 'lpOverview',
                                    noCompetences: true,
                                    userIds: [usr.studentId],
                                  });
                                },
                              },
                              {
                                id: '5_detailed_competence_lp_report',
                                title: t(
                                  'report.courseOverviewDetailedCompetences'
                                ),
                                onClick: async () => {
                                  setIsOpenDownloadtReportModal(true);
                                  setPayloadDownload({
                                    formType: 'lpOverview',
                                    userIds: [usr.studentId],
                                  });
                                },
                              },
                              {
                                id: '6_lp_report',
                                title: t('report.lpOverview'),
                                onClick: async () => {
                                  setIsOpenDownloadtReportModal(true);
                                  setPayloadDownload({
                                    formType: 'lpOverview',
                                    userIds: [usr.studentId],
                                    noCompetences: true,
                                    noBirth: true,
                                    noDiploma: true,
                                    noNodes: true,
                                  });
                                },
                              },
                              {
                                id: '7_competence_lp_report',
                                title: t('report.courseOverviewCompetences'),
                                onClick: async () => {
                                  setIsOpenDownloadtReportModal(true);
                                  setPayloadDownload({
                                    formType: 'lpOverview',
                                    userIds: [usr.studentId],
                                    noBirth: true,
                                    noDiploma: true,
                                    noNodes: true,
                                  });
                                },
                              },
                            ],
                          },
                        ]}
                        styleDropdown={{
                          top: '-30px',
                          left: 'auto',
                          right: '115%',
                        }}
                        screensUpdateTable="desktop"
                        pageDetail={pageDetail}
                        rowInfo={usr}
                        positionDropdown={true}
                        mobileHeader={{
                          render: (usr: any) => (
                            <div className="flex items-center">
                              <PersonAvatar
                                inline
                                id={usr.id}
                                name={usr.username || ''}
                                imageSrc={usr.picture || undefined}
                              ></PersonAvatar>
                              <div>
                                <div className="text-sm font-medium">
                                  {usr.username}
                                </div>
                                <div className="text-xs text-[#7d7d81]">
                                  {usr.email}
                                </div>
                              </div>
                            </div>
                          ),
                        }}
                      />
                    ),
                  },
                ]}
              />
              {isOpenUser && activeFollower && (
                <RigthSidebar
                  key={resetSidebar}
                  setIsOpenUser={setIsOpenUser}
                  activeFollower={activeFollower}
                  setActiveUser={setActiveUser}
                  setActiveFollower={setActiveFollower}
                  learningpath={learningpath}
                  setResetTable={setResetUserTable}
                  user={true}
                />
              )}
            </div>
          </Fragment>
        )}
        {tab === 'teams' && (
          <div ref={tableRef}>
            <TeamsTableLP
              fetch={useGet.bind(null, '/lpteamdetails', {
                lpgroupId: learningpath?.id,
                organisationId: organisationId,
                onSuccess: (result: any) => {
                  if (result?.data?.length > 0) {
                    setTeams(result?.data);
                  }
                },
              })}
              rowPath={(team: any) => `${teamPath}/${team.id}`}
              organisationId={organisationId}
              empty={{
                template: 1,
                text: t('empty_tenplate.team_list'),
                btn_text: t('empty_tenplate.btn_add_team'),
                btnClick: () => setShareSettings(true),
              }}
              teameCourse={true}
              lpgroupId={learningpath?.id}
              refetch={() => refetch()}
            />
            {isOpenTeam && selectedTeam && (
              <RigthSidebar
                key={resetSidebar}
                setIsOpenUser={setIsOpenTeam}
                activeFollower={selectedTeam}
                setActiveUser={setActiveTeam}
                setActiveFollower={setSelectedTeam}
                learningpath={learningpath}
                setResetTable={null}
              />
            )}
          </div>
        )}
        {tab === 'content' && (
          <div>
            <LearningPathContent
              key={resetContent}
              authOrg={authOrg}
              authUser={authUser}
              content={content}
              learningpath={learningpath}
              organisationId={authUser?.activeOrganisationId}
              setResetContent={setResetContent}
            />
          </div>
        )}
        {isOpenDownloadReportModal && (
          <ReportDownloadModal
            user={auth?.user}
            closeModal={() => {
              setIsOpenDownloadtReportModal(false);
              setPayloadDownload(null);
            }}
            payloadDownload={payloadDownload}
            courseId={null}
            lpgroupId={lpgroupId}
            organisationId={organisationId}
          />
        )}
        {isOpenCommentModal && (
          <OpenCommentModal
            closeModal={() => setIsOpenCommentModal(false)}
            setIsOpenCommentModal={setIsOpenCommentModal}
            lpgroupId={lpgroupId}
            usr={usr}
            refresh={() => {
              refetch();
              setResetUserTable(newUid(20));
            }}
            learningpath={learningpath}
            authUser={authUser}
          />
        )}
        {isOpenDownloadtModal && downloadReportPayload && (
          <DownloadReportModal
            report="courses"
            closeModal={() => {
              setIsOpenDownloadtModal(false);
              setDownloadReportPayload(null);
            }}
            setIsOpenDownloadtModal={(open: boolean) => {
              setIsOpenDownloadtModal(open);

              if (!open) {
                setDownloadReportPayload(null);
              }
            }}
            stateReport={undefined}
            user={auth?.user}
            updateStateReport={undefined}
            allSelect={undefined}
            courseType={null}
            reportPayload={downloadReportPayload}
            reportUrl={`${config.teoreport}/report/?lang=${i18n.language}`}
            downloadFn={downloadLink}
            resetSelection={false}
          />
        )}
        {isOpenDeleteModal && (
          <ComponentDeleteModal
            closeModal={() => setIsOpenDeleteModal(false)}
            setIsOpenDeleteModal={setIsOpenDeleteModal}
            title={t('delete_modal.title_user') + usrDelete?.username}
            heading={t('delete_modal.heading_user')}
            text={t('delete_modal.text_user_lp')}
            handleDelete={() => handleDeleteUser(usrDelete)}
          />
        )}
      </div>
    </>
  );
}

export default LearningPathDetails;
